import React from 'react';

interface CountrySelectorProps {
    countryCode: 'eu' | 'latam' | 'us';
    vehicleType: 'auto' | 'moto' | 'performance';
    onCountryChange: (code: 'eu' | 'latam' | 'us') => void;
}

const CountrySelector: React.FC<CountrySelectorProps> = ({ countryCode, vehicleType, onCountryChange }) => {
    return (
        <div id="catalogo-nav" className="flex items-center justify-center mb-4">
            <div className="font-medium mr-3">Catálogo</div>
            <div className="flex align-middle gap-1">
                {(vehicleType === 'auto' || vehicleType === 'performance') && (
                    <>
                        <span
                            className={`link-catalog ${countryCode === 'eu' ? 'active' : ''}`}
                            onClick={() => onCountryChange('eu')}
                            role="button"
                        >
                            Europa
                        </span>
                        <span
                            className={`link-catalog ${countryCode === 'us' ? 'active' : ''}`}
                            onClick={() => onCountryChange('us')}
                            role="button"
                        >
                            USA/Canadá
                        </span>
                        <span
                            className={`link-catalog ${countryCode === 'latam' ? 'active' : ''}`}
                            onClick={() => onCountryChange('latam')}
                            role="button"
                        >
                            Mex/Latam
                        </span>
                    </>
                )}

                {vehicleType === 'moto' && (
                    <span
                        className={`link-catalog ${(countryCode === 'eu' && vehicleType === 'moto') ? 'active' : ''}`}
                        role="button"
                    >
                        WorldWide
                    </span>
                )}
            </div>
        </div>
    );
};

export default CountrySelector;